import { isObjectOrArray } from '@utils/guards'
import { propEq } from 'rambda'

export const factory = factoryFunction => (_, getters) => (overrides = {}) => ({
  ...factoryFunction(getters),
  ...overrides,
})

export const hashPagination = ({ $limit, $skip }) => `${$limit || 20}|${$skip || 0}`
export const hashQuery = query => JSON.stringify(query)
export const omitPagination = ({ $skip, $limit, ...query }) => query

export const getterOptions = (getterKey, nullOption) => (_, getters) => [
  ...nullOption ? [nullOption] : [],
  ...getters[getterKey].map(({ label, value }) => [value, label]),
]

export const getterFinder = getterKey => (_, getters) => valueToFind =>
  getters[getterKey].find(propEq('value', valueToFind))

export const stateOptions = (labelKey = 'name', nullOption) => {
  const getValue = typeof labelKey === 'function'
    ? labelKey
    : record => record[labelKey]

  return state => [
    ...nullOption ? [nullOption] : [],
    ...Object
      .values(stateList(state))
      .map(record => [
        record.id,
        getValue(record),
      ])
      .filter(([_, label]) => label),
  ]
}

export const stateList = state => state.list || state

export const toActionName = name => name
  .split(/(?=[A-Z])/)
  .join('_')
  .toUpperCase()

function convertRecordDates(record) {
  if (!record) return record

  Object
    .keys(record)
    .forEach((key) => {
      if (!record[key]) return

      if (key.endsWith('At') || key.endsWith('Date')) {
        record[key] = new Date(record[key])
      } else if (isObjectOrArray(record[key])) {
        if (Array.isArray(record[key])) {
          record[key].forEach(convertRecordDates)
        } else {
          convertRecordDates(record[key])
        }
      }
    })

  return record
}

// NOTE: mutates
export const parseObject = object => convertRecordDates(object)
